import { NgIf } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ClearedCheckImportRequest, ClearedCheckImportResult } from '@app/models/fund-management';
import { ModalComponent } from '@app/shared/components';
import { FileUploadComponent } from '@app/shared/components/file-upload/file-upload.component';
import { UploadedFileModel } from '@app/shared/components/file-upload/models/uploaded-file.model';
import { ImportClearedChecksService } from '../services/import-cleared-checks.service';

@Component({
	selector: 'fm-cash-management-import-cleared-checks',
	templateUrl: './import-cleared-checks.component.html',
	styleUrls: ['./import-cleared-checks.component.less'],
	encapsulation: ViewEncapsulation.None,
	standalone: true,
	imports: [NgIf, FileUploadComponent],
})
export class ImportClearedChecksComponent implements OnChanges {
	@Input() bankId: number;
	@Input() statementDate: Date;
	@Output() importResult: EventEmitter<ClearedCheckImportResult> = new EventEmitter<ClearedCheckImportResult>();

	importEnabled = false;

	constructor(private readonly service: ImportClearedChecksService, private readonly resultsDialog: MatDialog) {}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.bankId?.currentValue) {
			this.service.isImportEnabledForBank(this.bankId).subscribe((isEnabled: boolean) => {
				this.importEnabled = isEnabled;
			});
		}
	}

	fileChangeEvent(uploadedFile: UploadedFileModel): void {
		const request: ClearedCheckImportRequest = { bankId: this.bankId, statementDate: this.statementDate, importText: uploadedFile.filePlainText };

		this.service.importClearedChecks(request).subscribe((data: ClearedCheckImportResult) => {
			this.importResult.emit(data);

			let message;
			if (data.importCount > 0) {
				message = `
						Number of Checks in Import File: ${data.importCount}<br />
						Number of Cleared Checks: ${data.clearedCount}<br />
						Number of Mismatches: ${data.amountMismatchCount}`;
			} else {
				message = 'No records available for import, or file format is invalid.';
			}

			this.resultsDialog.open(ModalComponent, {
				data: {
					title: 'Import Results',
					message,
					okText: 'OK',
					showCancel: false,
				},
			});
		});
	}
}
